import React, { Component } from "react";
import {
  companyUnload,
  fetchAgencyFeatures,
  fetchBookingDesks,
  fetchCompany,
  fetchCompanyBranches,
  fetchCorporateRoles,
  fetchCountries,
  fetchRoles,
  unloadAgencyBookingDesks,
  unloadAgencyFeatures,
  unloadCompanyBranches,
} from "../../../redux/actions";
import { connect } from "react-redux";
import {
  isAgency,
  isAgencyAdmin, isAgencyUser, isCorporate,
  isRolePlatformAdmin,
  token,
} from "../../../modules/auth";
import CompanyEdit from "./CompanyEdit";
import { fetchIndustries } from "../../../modules/industries";
import { fetchCompanyUserInvites } from "../../../redux/actions/corporateInvites";
import startCase from "lodash/startCase";
import { isCompanyAdmin, isCompanyUser, isInternal } from "../../../modules/permissions";
import AdminPageWIthSideBarDynamic from "../../../Components/Layout/AdminPageWIthSideBarDynamic";
import CompanyHubspot from "./Company/CompanyHubspot";
import CompanyBranches from "./Company/CompanyBranches";
import CompanyAgency from "./Company/CompanyAgency";
import CompanyUsers from "./Company/CompanyUsers";
import { getSuperAgencyPill } from "../../../utils";
import NotFound from "../../NotFound";

const mapStateToProps = state => {
  return {
    ...state.company,
    ...state.countries,
    ...state.roles,
    ...state.industries,
    ...state.userInvites,
    ...state.companyBranches,
    ...state.agencyBookingDesks,
    auth: state.auth,
    isCompanyAdmin: isCompanyAdmin(state.auth),
    isCompanyUser: isCompanyUser(state.auth),
    isCorporate: isCorporate(state),
    isAgency: isAgency(state),
    isAgencyAdmin: isAgencyAdmin(state),
    isAgencyUser: isAgencyUser(state),
    isInternal: isInternal(state.auth),
    token: token(state),
    isFetchingCompany: state.company.isFetchingCompany,
    isFetchingCompanyBranches: state.companyBranches.isFetchingCompanyBranches,
    isRolePlatformAdmin: isRolePlatformAdmin(state),
  };
};

const mapDispatchToProps = {
  fetchCompany,
  fetchCountries,
  fetchIndustries,
  companyUnload,
  fetchRoles,
  fetchCorporateRoles,
  fetchCompanyUserInvites,
  fetchCompanyBranches,
  unloadCompanyBranches,
  fetchBookingDesks,
  unloadAgencyBookingDesks,
  fetchAgencyFeatures,
  unloadAgencyFeatures,
};

class CompanyContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUserRoles: [],
      companyId: null,
    };
    this.sectionTypes = this.sectionTypes.bind(this);
  }

  componentDidMount() {
    this.props.fetchRoles(this.props.token);
    this.props.fetchCorporateRoles(this.props.token);
    let companyId =
      typeof this.props.match.params.id === "undefined"
        ? this.props.auth.user.company_id
          ? this.props.auth.user.company_id
          : null
        : this.props.match.params.id;
    this.setState({
      companyId: companyId,
    });
    if (companyId) {
      this.props.fetchCompany(companyId, this.props.token).then(response => {
        if (response.data.data.agency_id) {
          this.props.fetchBookingDesks(
            response.data.data.agency_id,
            this.props.token,
            false,
            true
          );
          this.props.fetchAgencyFeatures(
            this.props.token,
            response.data.data.agency_id
          );
        }
        let cur = response.data.data.users
          .sort((a, b) => a.email.localeCompare(b.email))
          .map(user => {
            return [
              {
                user: user.id,
                roles: user.corporate_roles.map(role => {
                  return {
                    label: startCase(role),
                    value: role,
                  };
                }),
              },
            ];
          });
        this.setState({ currentUserRoles: cur });
      });
    } else {
    }

    this.props.fetchCountries(this.props.token);
    this.props.fetchIndustries(this.props.token);
    this.props.fetchCompanyUserInvites(companyId, this.props.token);
    this.props.fetchCompanyBranches(companyId, this.props.token);
  }

  componentWillUnmount() {
    this.props.unloadCompanyBranches();
    this.props.unloadAgencyBookingDesks();
    this.props.unloadAgencyFeatures();
  }

  sectionTypes() {
    const {
      company,
      isRolePlatformAdmin,
      isAgencyAdmin,
      isAgencyUser,
      accessDenied,
    } = this.props;
    if (accessDenied) {
      return [];
    }

    let tabs = [
      {
        name: "Edit",
        overrideLabel: "Profile",
        component: null,
        visible: true,
      },
      { name: "Users", component: null, visible: true },
    ];
    if (isRolePlatformAdmin) {
      tabs.push({
        name: "Hubspot",
        component: null,
        visible: isRolePlatformAdmin,
      });
    }
    if ((isAgencyAdmin || isRolePlatformAdmin) && !company.is_dummy_company) {
      tabs.push({
        name: "Branches",
        component: null,
        visible:
          (isAgencyAdmin || isRolePlatformAdmin) && !company.is_dummy_company,
      });
    }
    if ((isAgencyAdmin || isRolePlatformAdmin ||isAgencyUser) && !company.is_dummy_company){
      tabs.push({
        name: "Agency",
        component: null,
        visible:
          ((isAgencyAdmin || isRolePlatformAdmin || isAgencyUser) && !company.is_dummy_company) ,
      });
    }

    return tabs;
  }

  render() {
    const {
      company,
      isFetchingCompany,
      companyBranches,
      isFetchingCompanyBranches,
      countries,
      roles,
      industries,
      userInvites,
      corporateRoles,
      isCompanyAdmin,
      isCompanyUser,
      isCorporate,
      isAgencyUser,
      isAgency,
      isInternal,
      agencyBookingDesks,
      match,
      accessDenied,
      companyNotFound,
    } = this.props;
    const section = this.sectionTypes().find(
      s => s.name.toLowerCase() === match.params.section
    );
    const isVisible = section?.visible;

    const { companyId } = this.state;

    if (!companyId) {
      return (
        <NotFound>
          <p>
            You do not have permission to do that.
            <br />
            Sorry, it seems that your user does not have the right permission to
            access this page.
            <br />
            If you believe this is incorrect, please contact{" "}
            <a href={"mailto:info@edgevenues.com"}>info@edgevenues.com</a>
            with a screenshot of the page, and a copy of the webpage URL and a
            description of what you were doing. Sorry for any inconvenience.
          </p>
        </NotFound>
      );
    }

    return (
      <div className={"bg-white p-5 mt-10"}>
        {company && company.agency
          ? getSuperAgencyPill({ agency: company.agency })
          : null}

        {companyNotFound ? (
          <div className={"bg-white p-5"}>
            <h2
              className={
                "mb-4 md:flex md:flex-row md:justify-between md:items-center uppercase"
              }
            >
              Company not found
            </h2>
          </div>
        ) : accessDenied ? (
          <div className={"bg-white p-5"}>
            <h2
              className={
                "mb-4 md:flex md:flex-row md:justify-between md:items-center uppercase"
              }
            >
              You don't have access to this Company
            </h2>
          </div>
        ) : (
          <AdminPageWIthSideBarDynamic
            headerText={`Manage Company: ${company.name}`}
            basePath={isCompanyUser && isCorporate ?`/company/` : (isCompanyUser ? `/admin/company/` : `/admin/agency/company/${company.id}/`)}
            sectionTypes={this.sectionTypes()}
            match={match}
          >
            {isVisible && match.params.section === "edit" ? (
              <CompanyEdit
                company={company}
                fetchCompany={fetchCompany}
                userInvites={userInvites}
                isFetchingCompany={isFetchingCompany}
                countries={countries}
                roles={roles}
                corporateRoles={corporateRoles}
                industries={industries}
                isCompanyAdmin={isCompanyAdmin}
                isAgency={isAgency}
                isInternal={isInternal}
                currentUserRoles={this.state.currentUserRoles}
                companyBranches={companyBranches}
                isFetchingCompanyBranches={isFetchingCompanyBranches}
                agencyBookingDesks={agencyBookingDesks}
              />
            ) : null}
            {isVisible && match.params.section === "users" ? (
              <CompanyUsers
                company={company}
                userInvites={userInvites}
                isFetchingCompany={isFetchingCompany}
                countries={countries}
                roles={roles}
                corporateRoles={corporateRoles}
                industries={industries}
                isCompanyAdmin={isCompanyAdmin}
                isAgency={isAgency}
                isInternal={isInternal}
                currentUserRoles={this.state.currentUserRoles}
                companyBranches={companyBranches}
                isFetchingCompanyBranches={isFetchingCompanyBranches}
                agencyBookingDesks={agencyBookingDesks}
              />
            ) : null}
            {isVisible && match.params.section === "agency" ? (
              <CompanyAgency company={company} />
            ) : null}

            {isVisible && match.params.section === "hubspot" ? (
              <CompanyHubspot company={company} />
            ) : null}

            {isVisible && match.params.section === "branches" ? (
              <CompanyBranches
                countries={countries}
                companyBranches={companyBranches}
                isFetchingCompanyBranches={isFetchingCompanyBranches}
                addNewCompanyBranch={this.state.addNewCompanyBranch}
              />
            ) : null}
          </AdminPageWIthSideBarDynamic>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyContainer);
